// 加盟店申請(包括)画面のラベル
export const LABELS = {
  APPLICATION_TARGET_SERVICE: "申請対象サービス",
  APPLICATION_FILE: "変換ファイル",
  APPLICATION_MANUAL: "申請マニュアル",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  FOR_MERCHANT: "加盟店項目用",
  FOR_DOCOMO: "ドコモ項目用",
  NO: "No",
  ERROR_DETAIL: "エラー内容",
  ERROR_FILENAME: "エラーファイル名",
  ERROR_OCCURRED_PLACE: "エラー発生箇所",
  ERROR_TITLE_FOR_MERCHANT: "加盟店項目用エラー内容",
  ERROR_TITLE_FOR_DOCOMO: "ドコモ項目用エラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION_XLSX: ".xlsx",
  FILE_EXTENSION_XLSM: ".xlsm",
  FILE_EXTENSION_MERCHANT_ACCEPT: ".xlsx, .xlsm",
  UPLOAD_TYPE: "uploadType",
  MERCHANT: "加盟店項目用",
  DOCOMO: "ドコモ項目用",
  COMPANY_CODE: "comprehensiveCompanyCode",
  SUCCESS: "success",
  SELECT_ITEM: "selectItem",
  SEPARATOR: "（",
} as const;

export const CONTENTS = {
  APPLICATION_CONFIRM_MERCHANT: "\r\n・加盟店項目用{0}",
  APPLICATION_CONFIRM_DOCOMO: "\r\n・ドコモ項目用\r\n　　ファイル名：{0}",
  APPLICATION_CONFIRM_MERCHANT_FILE: "\r\n　　ファイル名：",
} as const;
